module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"pageTitle":"Portfolio erstellen","portfolioNameLabel":"Name","submitButtonLabel":"Erstellen","errorHeader":"Beim Speichern ist ein Fehler aufgetreten"}}')
  delete Component.options._Ctor
}
